// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2sNZ1","range":"MonthRangeSwitch_range__2uQ0q","disabled":"MonthRangeSwitch_disabled__8XVfI"};